import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CreditActions from "../../../store/credit/actions";
import { getServiceKey, useBureauPermission } from "../../../util/credit";
import { getDate } from "../../../util/date";
import * as httpClient from "../../../util/httpClient";
import { ApplicationState } from "../../../store";
import { useTranslation } from "react-i18next";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { ezsServiceIds } from "../../../config/UserServicesList";
import { useAreServicesActive, getActiveServiceCode } from "../../../util/CommonServices";

interface IProps {
    updateComponent?: any;
    updateDate?: string;
    nextAvailableUpdate?: string;
    serviceCode?: string;
    isIDFUser?: boolean;
    isTUUser?: boolean;
    isDashboardView?: boolean;
    combinationRefresh?: boolean;
    isOneTimeReport?: boolean;
}

const UpdateScore: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    const bureauPermission = useBureauPermission();
    const dispatch = useDispatch();
    const requestCreditData = () => dispatch(CreditActions.actionCreators.requestCreditData(true, bureauPermission));
    const refreshCredit = () => dispatch(CreditActions.actionCreators.refreshCredit(false, null, props.serviceCode));
    const refreshDailyCredit = () => dispatch(CreditActions.actionCreators.refreshDailyCredit(true, null, dailyServiceCode));
    const [isLoading, setIsLoading] = useState(false);
    const [showRefreshScore, setShowRefreshScore] = useState(false);
    const [nextPullInYears, setNextPullInYears] = useState(-1);

    const dailyRefreshableCreditServiceIds = [ezsServiceIds.tuDailyCreditReportWithScore, ezsServiceIds.tuDailyCreditReport];
    const dailyServiceCode = getActiveServiceCode(dailyRefreshableCreditServiceIds);

    const servicesNotAllowedForRefrsh = [ezsServiceIds.tuQuarterlyCreditScore];
    const notAllowedServiceToRefresh = useAreServicesActive(servicesNotAllowedForRefrsh) || props.isOneTimeReport;
    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (props.isIDFUser) {
            setIsLoading(true);
            const requestBody = {
                "bureau-opt": getServiceKey(bureauPermission),
            };
            httpClient
                .sendRequest("POST", `api/credit-monitoring/refreshCreditData`, requestBody)
                .then((data) => {
                    requestCreditData();
                    setIsLoading(false);
                })
                .catch(function (error) {
                    requestCreditData();
                    setIsLoading(false);
                });
        }

        if (props.isTUUser) {
            if (props.updateComponent) {
                props.updateComponent();
            } else {
                if (props.combinationRefresh) {
                    refreshDailyCredit();
                } else {
                    refreshCredit();
                }
            }
            requestCreditData();
        }
    };
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    useEffect(() => {
        let today = getDate(new Date().setHours(0, 0, 0, 0));
        let nextPull = props.nextAvailableUpdate == null ? getDate(props.updateDate) : getDate(props.nextAvailableUpdate);
        let diff = today.diff(nextPull, "days");
        let yearDiff = nextPull.diff(today, "years");

        if (nextPullInYears === -1) {
            setNextPullInYears(yearDiff);
        }

        if (!isNaN(diff) && nextPull.diff(today, "days") <= 0 && props.tuStatus !== "TU-Fulfill-Pull-Error") {
            setShowRefreshScore(true);
        } else {
            setShowRefreshScore(false);
        }
    }, [props.nextAvailableUpdate]);

    return (
        <React.Fragment>
            <div className={`${isLoading && "loading"}`}>
                <div className="row between-xs">
                    <div className="col-xs col-gutter-vertical flex-grow-null">
                        {showRefreshScore === false ? (
                            <ul className="list-reset margin-bottom-s credit-report-dates">
                                {!props.isDashboardView && (
                                    <li>
                                        <em className="las la-calendar-check icon-inline"></em>{" "}
                                        <strong>{tLang("credit.creditScore.creditScoreWidget.label.updatedDate")}:</strong>{" "}
                                        {props.updateDate && getFormattedDate(i18nService.get("Country"), props.updateDate)}
                                    </li>
                                )}
                                {!props.isDashboardView && (props.isIDFUser || props.isTUUser) && nextPullInYears < 2 && props.tuStatus !== "TU-Fulfill-Pull-Error" ? (
                                    <li>
                                        <em className="las la-calendar-day icon-inline"></em>{" "}
                                        <strong>{tLang("credit.creditScore.creditScoreWidget.label.nextUpdateDate")}:</strong>{" "}
                                        {props.nextAvailableUpdate && getFormattedDate(i18nService.get("Country"), props.nextAvailableUpdate)}
                                    </li>
                                ) : null}
                            </ul>
                        ) : (
                            <React.Fragment>
                                {!props.isDashboardView && (
                                    <ul className="list-reset margin-bottom-s credit-report-dates">
                                        <li>
                                            <em className="las la-calendar-check icon-inline"></em>{" "}
                                            <strong>{tLang("credit.creditScore.creditScoreWidget.label.updatedDate")}:</strong>{" "}
                                            {props.updateDate && getFormattedDate(i18nService.get("Country"), props.updateDate)}
                                        </li>
                                    </ul>
                                )}

                                {(props.isIDFUser || props.isTUUser) && !notAllowedServiceToRefresh ? (
                                    <button
                                        type="button"
                                        className="btn-default btn-primary"
                                        onClick={(e: any) => {
                                            handleSubmit(e);
                                            window.addToDataLayer({ event: "Refresh Score" });
                                        }}
                                    >
                                        <span className="btn-text">{tLang("credit.creditScore.creditScoreWidget.refreshScorebtn")}</span>
                                    </button>
                                ) : null}
                            </React.Fragment>
                        )}
                    </div>
                    <div className="col-xs col-gutter-vertical flex-grow-null"></div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UpdateScore;
